import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { Contact } from '@shared/services/contact-b2c/models';

@Injectable({ providedIn: 'root' })
export class ContactB2cService extends ApiServiceBase<Contact> {
  constructor() {
    super('contact/b2c', 'contactB2C', 'fournierWebservice');
  }
}
